<template>
<div id="app_main">
  <!-- HEADER -->
  <div class="header__top">
    <div class="header__logo"></div>
    <div class="header__menu">
      <a href="/main/">Realms.ru</a> | <a>Аваторы</a> | <a href="https://axistown.ru">Axistown</a> |
      <a href="/">Наши Форумы</a> |
      <a class="decoration_2020" href="https://t.me/rpgplanetfoyer">Telegram-канал в {{new Date().getFullYear()}}</a>
    </div>
  </div>

  <!-- BODY -->
  <div style="display: flex;">
    <!-- LEFT COLUMN -->
    <div style="flex: 1; min-width: 158px; max-width: 158px;">
      <div class="main__left_top"></div>
      <div class="sidepanel__content sidepanel__left">
        <br>
        <div class="sidepanel__title">Меню сайта</div>
        <p><a href="/main/">Новости</a> <a href="/main/?actions=news" class="main__silver_url">(разделы)</a></p>
        <p><a href="/main/?actions=articles">Статьи</a></p>
        <p><a>Галерея</a></p>
        <p><a>Файлы</a></p>
        <p><a>Ссылки</a></p>
        <p><a href="/">Наши форумы</a></p>
        <p><a href="/main/?actions=viewnews&page=364">Наш чат</a></p>
        <p><a href="/main/?actions=viewarticles&page=263">О сайте</a></p>
        <br><br>
        <div class="sidepanel__title">Подробнее о...</div>
        <p><a href="/main/?actions=articles&sections=1">Neverwinter Nights</a></p>
        <p><a href="/main/?actions=articles&sections=2">Shad. of Undrentide</a></p>
        <p><a href="/main/?actions=articles&sections=8">Hor. of the Underdark</a></p>
        <p><a href="/main/?actions=articles&sections=6">Lionheart</a></p>
        <p><a href="/main/?actions=articles&sections=3">World of Warcraft</a></p>
        <p><a href="/main/?actions=articles&sections=9">Temple of Elem. Evil</a></p>
        <p><a href="/main/?actions=articles&sections=5">Dungeons & Dragons</a></p>
        <br><br>
        <div class="sidepanel__title">Наши проекты</div>
        <p><a>Neverwinter.Ru</a></p>
        <p><a>Axistown</a></p>
        <br><br>
        <div class="sidepanel__title">Наши кланы</div>
        <div style="width: 123px; text-align: center;">
          <div><a href="https://web.archive.org/web/20040729165558/http://www.lflguild.com/"><img src="/clan1.gif" /></a></div>
          <div><a href="https://web.archive.org/web/20030118102555/http://koyars.narod.ru/"><img src="/clan2.gif" /></a></div>
          <div><a href="https://web.archive.org/web/20030207154041/http://www.soulshunters.ru/"><img src="/clan3.gif" /></a></div>
        </div>
        <br><br>
        <div class="sidepanel__title">Статистика</div>
        <div class="main__counters">
          <div><a><img src="/hotlog.gif" /></a></div>
          <div><a><img src="/spylog.gif" /></a></div>
          <div><a><img src="/mailru.gif" /></a></div>
          <div><a><img src="/gametop.gif" /></a></div>
        </div>
      </div>
      <div class="main__left_bottom"></div>
    </div>

    <!-- CENTER COLUMN -->
    <div style="flex: 1; flex: auto;">
      <div class="main__center_top_frame"></div>
      <div class="main__content">
        <!-- http://realms.test:8080/main/?actions=stats&t=2&user=522 t=2 is news
          or http://realms.test:8080/main/?actions=stats&t=3&user=522 t=3 is articles -->
        <StaticPage :findNewsByUser="true" v-if="($route.query.actions && $route.query.actions.toUpperCase() == 'STATS'
        && ($route.query.t && $route.query.user) && $route.query.t == '2')" />
        <StaticPage :findArticlesByUser="true" v-else-if="($route.query.actions && $route.query.actions.toUpperCase() == 'STATS'
        && ($route.query.t && $route.query.user) && $route.query.t == '3')" />

        <!-- http://realms.test:8080/main/?actions=division
          or http://realms.test:8080/main/?actions=articles -->
        <StaticPage :listArticleSections="true" v-else-if="($route.query.actions && ($route.query.actions.toUpperCase() == 'DIVISION' || $route.query.actions.toUpperCase() == 'ARTICLES')
        && (!$route.query.sections && !$route.query.ions && !$route.query.category))" />
        <!-- http://realms.test:8080/main/?actions=division&sections=1
          or http://realms.test:8080/main/?actions=articles&sections=1 -->
        <StaticPage :listArticleCategories="true" v-else-if="($route.query.actions && ($route.query.actions.toUpperCase() == 'DIVISION' || $route.query.actions.toUpperCase() == 'ARTICLES')
        && ($route.query.sections || $route.query.ions) && !$route.query.category)" />
        <!-- http://realms.test:8080/main/?actions=division&sections=1&category=1
          or http://realms.test:8080/main/?actions=articles&sections=1&category=1 -->
        <StaticPage :listArticlesByCategory="true" v-else-if="($route.query.actions && ($route.query.actions.toUpperCase() == 'DIVISION' || $route.query.actions.toUpperCase() == 'ARTICLES')
        && $route.query.category)" />

        <!-- http://realms.test:8080/main/?actions=news -->
        <StaticPage :displayNewsCategories="true" v-else-if="($route.query.actions && $route.query.actions.toUpperCase() == 'NEWS' && (!$route.query.ions && !$route.query.category))" />
        <!-- http://realms.test:8080/main/?actions=news&category=1
          or http://realms.test:8080/main/?actions=news&ions=1 -->
        <MainNews :articleCategory="true" v-else-if="($route.query.actions && $route.query.actions.toUpperCase() == 'NEWS' && ($route.query.ions || $route.query.category))" />
        <!-- http://realms.test:8080/main/?actions=viewnews&page=1
          or http://realms.test:8080/main/?actions=viewarticles&page=1 -->
        <MainArticle v-else-if="($route.query.actions && ($route.query.actions.toUpperCase() == 'VIEWNEWS' || $route.query.actions.toUpperCase() == 'VIEWARTICLES') && $route.query.page)" />
        <!-- http://realms.test:8080/main/ -->
        <MainNews :viewArhive="true" v-else />
      </div>
      <div class="main__center_bottom_frame"></div>
    </div>

    <!-- RIGHT COLUMN -->
    <div style="flex: 1; min-width: 158px; max-width: 158px;">
      <div class="main__right_top"></div>
      <div class="sidepanel__content sidepanel__right">
        <div style="padding-left: 25px;">
          <br>
          <div class="sidepanel__title">Популярные<br>новости</div>
          <div class="sidepanel__link">
            <div><img src="/p2.gif" /></div>
            <div><a href="/main/?actions=viewnews&page=565#comments">Форум временно не работает</a> (127)</div>
          </div>
          <div class="sidepanel__link">
            <div><img src="/p.gif" /></div>
            <div><a href="/main/?actions=viewnews&page=703#comments">Не везет нам с хостингом</a> (26)</div>
          </div>
          <div class="sidepanel__link">
            <div><img src="/p.gif" /></div>
            <div><a href="/main/?actions=viewnews&page=566#comments">Конкурс</a> (20)</div>
          </div>
          <div class="sidepanel__link">
            <div><img src="/p.gif" /></div>
            <div><a href="/main/?actions=viewnews&page=569#comments">Neverwinter Nights от фирмы "1С"</a> (15)</div>
          </div>
          <div class="sidepanel__link">
            <div><img src="/p.gif" /></div>
            <div><a href="/main/?actions=viewnews&page=574#comments">Так что же нас ждёт!?</a> (10)</div>
          </div>

          <br>
          <div class="sidepanel__title">Обсуждаемые<br>статьи</div>
          <div class="sidepanel__link">
            <div><img src="/p2.gif" /></div>
            <div><a href="/main/?actions=viewarticles&page=763">Прохождение Hordes of the Underdark: Глава III</a> (61)</div>
          </div>
          <div class="sidepanel__link">
            <div><img src="/p2.gif" /></div>
            <div><a href="/main/?actions=viewarticles&page=527">Шлемы</a> (53)</div>
          </div>
          <div class="sidepanel__link">
            <div><img src="/p2.gif" /></div>
            <div><a href="/main/?actions=viewarticles&page=794">Neverwinter Nights... 2???</a> (49)</div>
          </div>
          <div class="sidepanel__link">
            <div><img src="/p2.gif" /></div>
            <div><a href="/main/?actions=viewarticles&page=631">Wizard - Маг</a> (45)</div>
          </div>
          <div class="sidepanel__link">
            <div><img src="/p2.gif" /></div>
            <div><a href="/main/?actions=viewarticles&page=790">Reliable Archer</a> (33)</div>
          </div>

          <br>
          <div class="sidepanel__title">Новые файлы</div>
          <div class="sidepanel__link">
            <div><img src="/p.gif" /></div>
            <div><a>Демо-версия Temple of Elemental Evil</a> (217)</div>
          </div>
          <div class="sidepanel__link">
            <div><img src="/p.gif" /></div>
            <div><a>Redblade 3.5e</a> (417)</div>
          </div>
          <div class="sidepanel__link">
            <div><img src="/p.gif" /></div>
            <div><a>Русификатор Lionheart</a> (156)</div>
          </div>
          <div class="sidepanel__link">
            <div><img src="/p.gif" /></div>
            <div><a>Карта Фаэруна</a> (444)</div>
          </div>
          <div class="sidepanel__link">
            <div><img src="/p.gif" /></div>
            <div><a>Карта Фаэруна #2</a> (320)</div>
          </div>

          <!--
          <br>
          <div class="sidepanel__title">Календарь</div>
          <p><a>...</a></p>
        -->

          <br>
          <div class="sidepanel__title">Наши партнеры</div>
          <div style="width: 123px; text-align: center;">
            <div class="sidepanel__partner"><a href="https://axistown.ru"><img src="/partner1.gif" /></a></div>
            <div class="sidepanel__partner"><a href="https://web.archive.org/web/20040611211933/http://www.gamefan.ru/"><img src="/partner2.gif" /></a></div>
            <div class="sidepanel__partner"><a href="https://web.archive.org/web/20040226205517/http://cgn.ru/"><img src="/partner5.gif" /></a></div>
            <div class="sidepanel__partner"><a href="https://web.archive.org/web/20040727020838/warcraft.ru"><img src="/partner6.gif" /></a></div>
            <div class="sidepanel__partner"><a href="https://web.archive.org/web/20010203114400/http://dungeon.ru/"><img src="/partner7.gif" /></a></div>
            <div class="sidepanel__partner"><a href="https://web.archive.org/web/20040611032340/http://gamezoom.ru/"><img src="/partner3.gif" /></a></div>
            <div class="sidepanel__partner"><a href="http://aerie.ru"><img src="/partner4.gif" /></a></div>
          </div>

        </div>
      </div>
      <div class="main__right_bottom"></div>
    </div>
  </div>

  <!-- FOOTER -->
  <div class="main__footer">
    <div>При использовании материалов ссылка на <a href="/main/">www.realms.ru</a> обязательна.</div>
  </div>
</div>
</template>

<script>
import MainNews from './components/MainNews'
import MainArticle from './components/MainArticle'
import StaticPage from './components/StaticPage'

export default {
  components: {
    MainNews,
    MainArticle,
    StaticPage,
  }
}
</script>

<style lang="scss">
@import "./main-colors.scss";
@import "./components/Main.scss";
</style>
